module.exports = __webpack_public_path__ + "static/media/banner_app.abdcd84b.jpg";